import Field from './Field';
import React, {Component} from 'react';

export default class RichTextEditor extends Component {
  render() {
    return (
      <Field {...this.props}>
        <input />
      </Field>
    );
  }
}

RichTextEditor.propTypes = {
  ...Field.propTypes,
};
